import React, { useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import { motion, AnimatePresence } from 'framer-motion';

// Fold-card thumbnail: hover (desktop) or press-and-hold (phones) shows a large preview of the scene
export const FoldThumb = ({ src, label }) => {
  const [zoom, setZoom] = useState(false);
  const timer = useRef(null);
  const held = useRef(false);
  useEffect(() => () => clearTimeout(timer.current), []);

  const later = (fn, ms) => { clearTimeout(timer.current); timer.current = setTimeout(fn, ms); };
  const handlers = {
    onMouseEnter: () => later(() => setZoom(true), 350),
    onMouseLeave: () => { clearTimeout(timer.current); setZoom(false); },
    onTouchStart: () => { held.current = false; later(() => { held.current = true; setZoom(true); navigator.vibrate?.(15); }, 350); },
    onTouchMove: () => clearTimeout(timer.current),
    onTouchEnd: (e) => { clearTimeout(timer.current); if (held.current) { e.preventDefault(); setZoom(false); } },
    onTouchCancel: () => { clearTimeout(timer.current); setZoom(false); },
    onContextMenu: (e) => e.preventDefault(),
  };

  return (
    <>
      <img src={src} alt={`${label} fold in your fabric`} loading="lazy" {...handlers}
        className="w-full h-full object-cover object-[50%_35%] select-none [-webkit-touch-callout:none] transition-transform duration-500 hover:scale-105"
        data-testid={`fold-style-${label.toLowerCase()}-thumb`} />
      {createPortal(
        <AnimatePresence>
          {zoom && (
            <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} transition={{ duration: 0.2 }}
              className="fixed inset-0 z-[200] flex items-center justify-center bg-black/25 pointer-events-none p-4" data-testid="fold-thumb-zoom">
              <motion.figure initial={{ scale: 0.92, y: 8 }} animate={{ scale: 1, y: 0 }} exit={{ scale: 0.95 }} transition={{ type: 'spring', stiffness: 300, damping: 26 }}
                className="bg-white rounded-2xl shadow-2xl overflow-hidden">
                <img src={src} alt={`${label} fold — large preview`} className="block h-[min(72vh,600px)] aspect-[3/4] object-cover bg-neutral-100" />
                <figcaption className="px-4 py-2.5 text-sm font-medium text-neutral-900" data-testid="fold-thumb-zoom-label">{label} fold</figcaption>
              </motion.figure>
            </motion.div>
          )}
        </AnimatePresence>,
        document.body,
      )}
    </>
  );
};
